import { EventMeta } from '../../../interfaces/meta.interface';

type TIMailDataDescFields = {
    P1Sender: string;
    P2Sender: string;
    SenderIp: string; // Sender information
    Subject: string;
    Recipients: string; // Recipient information
};

const tIMailData: EventMeta<any, TIMailDataDescFields> = {
    title: 'Malicious Mail Intercepted',
    default: {
        description: 'Malicious Mail Intercepted',
        longDescription: 'A Malicious Mail was intercepted.',
        severity: 'info',
    },
    descriptionExtractor: (log: any) => {
        return {
            P1Sender: log.P1Sender,
            P2Sender: log.P2Sender,
            SenderIp: log.SenderIp,
            Subject: log.Subject,
            Recipients: log.Recipients.join(', '),
        };
    },
    classifications: [
        {
            severity: 'warning',
            description: (fields) =>
                `A potentially harmful email "${fields.Subject}" was detected and blocked to protect users and organizational data`,
            longDescription: (fields) =>
                `A malicious email titled "${fields.Subject}" was intercepted. This action prevents possible exposure to phishing, malware, or other threats. Review the intercepted message and sender details to understand the threat and ensure no similar emails bypass defenses.`,
        },
    ],
};

export default tIMailData;
